import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TravelIcon from 'products/nomad_insurance/assets/img/claims/travel.svg';
import MedicalIcon from 'products/nomad_insurance/assets/img/claims/medical.svg';
import { CLAIM_TYPES } from '../../helpers';
import { ClaimTypeIcon } from './styled';
import { InfoText } from '../../styled';

export const ClaimTypeInfo = ({ claimType }) => {
  const src = claimType === CLAIM_TYPES.NON_MEDICAL ? TravelIcon : MedicalIcon;

  const claimTypeText = useMemo(() => {
    if (claimType === CLAIM_TYPES.NON_MEDICAL) return 'Travel';
    if (claimType === CLAIM_TYPES.MEDICAL) return 'Medical';
    return 'Direct medical';
  }, [claimType]);

  return (
    <InfoText>
      <ClaimTypeIcon src={src} alt={claimTypeText} />
      {claimTypeText}
    </InfoText>
  );
};

ClaimTypeInfo.propTypes = {
  claimType: PropTypes.string.isRequired
};
